import app from '../../forum/app';
import highlight from '../../common/helpers/highlight';
import Avatar from '../../common/components/Avatar';
import username from '../../common/helpers/username';
import Link from '../../common/components/Link';
/**
 * The `UsersSearchSource` finds and displays user search results in the search
 * dropdown.
 */
export default class UsersSearchResults {
  results = new Map();
  async search(query) {
    return app.store.find('users', {
      filter: {
        q: query
      },
      page: {
        limit: 5
      }
    }).then(results => {
      this.results.set(query, results);
      m.redraw();
    });
  }
  view(query) {
    query = query.toLowerCase();
    const results = (this.results.get(query) || []).concat(app.store.all('users').filter(user => [user.username(), user.displayName()].some(value => value.toLowerCase().substr(0, query.length) === query))).filter((e, i, arr) => arr.lastIndexOf(e) === i).sort((a, b) => a.displayName().localeCompare(b.displayName()));
    if (!results.length) return [];
    return [m("li", {
      className: "Dropdown-header"
    }, app.translator.trans('core.lib.search_source.users.heading')), ...results.map(user => {
      const name = username(user, name => highlight(name, query));
      return m("li", {
        className: "UserSearchResult",
        "data-index": 'users' + user.id()
      }, m(Link, {
        href: app.route.user(user)
      }, m(Avatar, {
        user: user
      }), name));
    })];
  }
}
flarum.reg.add('core', 'forum/components/UsersSearchSource', UsersSearchResults);